<template>
  <Modal
    v-model="isShow"
    :width="500"
    :loading="loading"
    :mask-closable="false"
    @on-ok="save"
  >
    <h3 slot="header" class="modal-header">取消拼团</h3>
    <Input
      v-model="cancelBy"
      :maxlength="100"
      :show-word-limit="true"
      placeholder="请输入取消拼团理由"
      type="textarea"
    ></Input>
  </Modal>
</template>

<script>
import { confirmOrCancelParticipate } from 'api/groupmanage'
export default {
  name:'CancelGroup',
  props:{
    n:{
      type: Number,
      default:0
    },
    fid:{
      type: String,
      default:''
    }
  },
  data(){
    return {
      cancelBy:'',
      loading: true,
      isShow: false,
    }
  },
  watch:{
    n(){
      this.cancelBy = ''
      this.isShow = true
    }
  },
  methods:{
    save(){
      if(this.cancelBy.length === 0){
        this.$Message.error('请填写取消理由')
        this.changeLoading();
        return false
      }
      if(this.cancelBy.length > 100){
        this.$Message.error('取消理由不能超过100字符')
        this.changeLoading();
        return false
      }
      // 调接口
      confirmOrCancelParticipate({
        itemFid:this.fid,
        cancelBy:this.cancelBy,
        participateStatus:3
      })
      .then(res=>{
        if(res.code === 0){
          this.$Message.success('取消拼团成功')
          this.$emit('search')
          this.isShow = false
        } else{
          this.$Message.info( '取消拼团失败')
          this.changeLoading()
        }
      })
      .catch( () => {
        this.$Message.info( '取消拼团失败')
        this.changeLoading()
      })
      .finally( ()=> {
        this.changeLoading()
      })

    },
    changeLoading(){
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
  }
}
</script>

<style>

</style>